
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M24 16H0v8h40v-8h-8zM24 32H0v8h40v-8h-8zM32 0H0v8h40V0z"}})])])
          )
        }
      }
    